export default __webpack_public_path__ + "static/media/005-bed.79461630.svg";